module.exports = __webpack_public_path__ + "static/media/asw.b5e50d18.png";